import React, { Component } from "react";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { IChannel } from "@formant/core/model/IChannel";
import { IDevice } from "@formant/core/model/IDevice";
import { IGroup } from "@formant/core/model/IGroup";
import { animate } from "@formant/ui/utils/animate";

import {
    appStore,
    organizationStore,
    shareStore,
    userStore,
} from "../../../stores";
import { CreateShare } from "./CreateShare";
import { GroupChooser } from "./GroupChooser";
import { ShareCreated } from "./ShareCreated";

export interface IShareFlowProps {
    channel?: IChannel;
    device?: IDevice;
    group?: IGroup;
}

@observer
export class ShareFlow extends Component<IShareFlowProps> {
    @observable
    private visible: boolean = true;
    @observable
    private url?: string;
    @observable
    private teleopUrl?: string;
    @observable
    private choosenGroup?: IGroup;

    public render() {
        const { channel, device, group } = this.props;
        const { visible, url, teleopUrl, choosenGroup, onClose } = this;

        const user = userStore.authenticated();
        const organization = organizationStore.authenticated();

        const hasShareItem =
            channel !== undefined ||
            device !== undefined ||
            group !== undefined ||
            choosenGroup !== undefined;

        if (!organization || !user) {
            return false;
        }

        const isTimelineVisible = !choosenGroup;

        return (
            <>
                <GroupChooser
                    visible={!hasShareItem}
                    onChoice={this.OnGroupChoice}
                    onClose={onClose}
                />
                {hasShareItem && (
                    <>
                        <CreateShare
                            visible={visible && !url}
                            channel={channel}
                            device={device}
                            group={this.choosenGroup || group}
                            isTimelineVisible={isTimelineVisible}
                            user={user}
                            organization={organization}
                            onClose={onClose}
                            onLinkCreated={this.onLinkCreated}
                        />
                        <ShareCreated
                            visible={visible && !!url}
                            url={url || ""}
                            teleopUrl={teleopUrl}
                            onClose={onClose}
                        />
                    </>
                )}
            </>
        );
    }

    private OnGroupChoice = (group: IGroup) => {
        this.choosenGroup = group;
    };

    private onLinkCreated = (url: string, teleopUrl?: string) => {
        this.url = url;
        this.teleopUrl = teleopUrl;
    };

    private onClose = async () => {
        this.visible = false;
        await animate();
        shareStore.clearList();
        appStore.sharing = false;
    };
}
